import { graphql } from 'react-apollo';

import { QUERY } from '../../../../../../../graphql/queries/accountHoldersQuery';
import { MUTATION } from '../../../../../../../graphql/mutations/removeDefaultFinancialAccount';

export default graphql(MUTATION, {
  props: ({ mutate }) => ({
    removeDefaultFinancialAccount: ({ accountHolderId }) =>
      mutate({
        variables: {
          accountHolderId: parseInt(accountHolderId, 10)
        }
      })
  }),
  options: {
    refetchQueries: [{ query: QUERY }],
    fetchPolicy: 'no-cache'
  }
});
